import React from 'react';
import {Container,Row,Col,Button} from 'react-bootstrap';



function Contatti() {
    return (
    
                <Container  fluid>
                    <Container style={{marginBottom:'30px'}} fluid id="banner_account" className="head-banner text-center text-white">
                        <Row>
                            <Col>
                                <h1><strong>8-Bit Motors</strong></h1>
                            </Col>
                        </Row>
                </Container>


                <section className="my-5">
                <h2 align="center" className="mb-3"><strong> Dove ci troviamo</strong></h2> 

        
        <Col lg="12">
          <div
            id="map-container"
            style={{ height: "600px" }}
          >
            <iframe src="https://www.google.com/maps/d/u/0/embed?mid=1Or11CujM5hSxzjYbixZv3Fzzht_2l4j4&ll=38.090860362626884%2C13.35919634929565&z=14" title="This is a unique title"
              width="100%"
              height="100%"
              frameBorder="0"
              style={{ border: 0 }}
            />
          </div>
          <br />
          <h2 align="center" className="mb-3"><strong> Contatti </strong></h2> 

          <Row className="text-center">
            <Col md="4">
              <Button variant="dark" tag="a"  className="accent-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-geo-alt-fill" viewBox="0 0 16 16">
              <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"/>
              </svg>
              </Button>
              <p>Palermo, 90121</p>
              <p className="mb-md-0">Italia</p>
            </Col>
            <Col md="4">
              <Button href="tel:+3939200123294" variant="dark" tag="a" className="accent-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-telephone-fill" viewBox="0 0 16 16">
              <path fillRule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"/>
              </svg>
              </Button>
              <p>Chiamaci al numero: +39 39200123294</p>
              <p className="mb-md-0">Lunedi - Venerdi, 8:00-22:00</p>
            </Col>
            <Col md="4">
              <Button href= "mailto:8bit.motors@gmail.com" variant="dark" tag="a" className="accent-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-envelope-fill" viewBox="0 0 16 16">
              <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555zM0 4.697v7.104l5.803-3.558L0 4.697zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757zm3.436-.586L16 11.801V4.697l-5.803 3.546z"/>
              </svg>
              </Button>
              <p>Inviaci un email cliccando qui!</p>
              <p className="mb-md-0">8bit.motors@gmail.com</p>
              
            </Col>
            
          </Row>
        </Col>
    </section>
           
            </Container>
        )
}

export default Contatti
